// AmenityCard.js
import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { motion } from 'framer-motion';

const AmenityCard = ({ icon, label, compact }) => {
  return (
    <motion.div whileHover={{ scale: 1.03 }}>
      <Tooltip title={label} arrow>
        <Box
          sx={{
            p: compact ? 1 : 2,
            backgroundColor: "rgba(255,255,255,0.08)",
            borderRadius: "4px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid rgba(255,255,255,0.12)",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.12)",
            },
          }}
        >
          <Box sx={{ color: "#fff", mb: compact ? 0.5 : 1 }}>
            {React.cloneElement(icon, { fontSize: compact ? "small" : "medium" })}
          </Box>
          <Typography
            variant={compact ? "caption" : "body2"}
            textAlign="center"
            noWrap={compact}
            sx={{
              maxWidth: "100%",
              textOverflow: "ellipsis",
              overflow: "hidden",
              color: "#fff",
              fontSize: compact ? "0.75rem" : "0.85rem",
            }}
          >
            {label}
          </Typography>
        </Box>
      </Tooltip>
    </motion.div>
  );
};

export default AmenityCard;